<template>
  <div id="MainBiddingComponent">
    <v-stepper v-model="stepIndex" alt-labels>
      <v-stepper-header>
        <v-stepper-step step="1"
          ><p class="text-center">Bidding Detail</p></v-stepper-step
        >
        <v-divider></v-divider>
        <v-stepper-step step="2"
          ><p class="text-center">Bidding Items</p>
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="3"
          ><p class="text-center">Bidding Attachment</p></v-stepper-step
        >
        <v-divider v-if="isAward"></v-divider>
        <v-stepper-step step="4" v-if="isAward"
          ><p class="text-center">Award</p></v-stepper-step
        >
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content
          :step="item.step"
          v-for="(item, index) in steps"
          :key="index"
          ><div
            class="pb-16"
            :is="item.component"
            @emitProjectDetail="callBackDataProjectDetail"
            @emitIsHaveFileTor="callBackIsHaveFileTor"
            @emitSubmitBiddingModel="callBackBiddingSubmitItem"
            @emitSubmitBiddingStep2Next="callBackBiddingStep2Next"
            @emitAttachmentAlreadyExist="callBackAttachmentAlreadyExist"
            @emitSubmitAttachmentStep3Next="callBackBiddingStep3Next"
            @emitSubmitAttachmentStep4Next="callBackBiddingStep4Next"
            @EmitAttachPo="callBackAttachment"
            @emitVendorAcknowledgePO="callBackUpdateBiddingStatusAcknowledgePO"
            :propIsEdit="isEdit"
            :propDataBiddingModelBack="backData"
            :propIsVendorValid="isVendorValid"
            :propCheckStep="checkStep"
            :propBiddingIsReview="dataProjectDetail.isUserReview"
            :propBiddingStatus="dataProjectDetail.biddingStatus"
            :onSaveDraft="isSaveDraft"
            :propIsSaveDraftDone="isSaveDraftDone"
          ></div>
          <v-row class="mb-6 mx-6">
            <v-btn
              v-show="item.step > 1"
              @click="stepIndex = item.step - 1"
              text
            >
              Back
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              color="secondary"
              v-show="item.step > 1 && isEdit"
              @click="save()"
            >
              Save
            </v-btn>
            <v-btn
              v-if="notjoinbidding && item.step === 1"
              class="mr-4"
              color="error"
              @click.prevent="updatenotjoinbidding()"
            >
              Not Join Bidding
            </v-btn>
            <v-btn color="primary" @click.prevent="onNextStep(item.step)">
              <!-- <v-btn color="primary" @click="stepIndex = item.step + 1"> -->
              {{
                isAward
                  ? item.step === 4
                    ? finishButton
                    : nextButtonText
                  : item.step === 3
                  ? finishButton
                  : nextButtonText
              }}
            </v-btn>
          </v-row>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <v-dialog v-model="dialog.show" width="500">
      <v-card>
        <v-card-title
          :class="
            dialog.type === 'error' ? 'red lighten-4' : 'light-green lighten-4'
          "
        >
          {{ dialog.title }}
        </v-card-title>
        <v-card-text class="mt-2">
          {{ dialog.text }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="primary" text @click="DiagloBidding">
            {{
              dialog.type === "success"
                ? "Join"
                : dialog.type === "error"
                ? "Close"
                : "Submit"
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import MainBiddingDetail from "./bidding-detail/MainBiddingDetail";
import { _projectservice } from "../../services/projectservice";

export default {
  name: "MainBiddingComponent",
  components: {
    MainBiddingDetail,
    MainProjectBidding: () => import("./project-bidding/MainProjectBidding"),
    MainAttachment: () => import("./project-attachment/MainAttachmentRow"),
    MainAward: () => import("./bidding-award/BiddingAward"),
  },
  data: () => ({
    stepIndex: 1,
    steps: [
      {
        icon: "icon-user",
        name: "Bidding Detail",
        component: "MainBiddingDetail",
        step: 1,
      },
      {
        icon: "icon-package",
        name: "Bidding Items",
        component: "MainProjectBidding",
        step: 2,
      },
      {
        icon: "icon-map",
        name: "Bidding Attachment",
        component: "MainAttachment",
        step: 3,
      },
    ],
    dataProjectDetail: {},
    dataBiddingSubmitItem: {},
    isHaveFileTor: false,
    isAward: false,
    backData: false,
    isVendorValid: false,
    checkStep: "",
    dialog: {
      show: false,
      title: "",
      text: "",
      type: "",
    },
    isHaveAttachFile: false,
    isHavePOFile: false,
    isSaveDraft: false,
    isSaveDraftDone: false,
  }),
  computed: {
    // Check vendor can bidding
    isEdit() {
      var retBidding = false;
      var retProject = false;
      // Check Bidding status

      switch (this.dataProjectDetail.biddingStatus) {
        case "Not Start":
          retBidding = true;
          break;
        case "Draft":
          retBidding = true;
          break;
        case "Submitted":
          retBidding = false;
          break;
        default:
          retBidding = true;
          break;
      }

      // Check project vendor status
      switch (this.dataProjectDetail.vendorProjectStatus) {
        case "Open":
          retProject = true;
          break;
        case "Re-Open":
          retProject = true;
          break;
        case "On Process":
          retProject = false;
          break;
        case "Completed":
          retProject = false;
          break;
        case "Award":
          retProject = false;
          break;
        default:
          retProject = false;
          break;
      }
      if (retBidding && retProject) return true;
      else return false;
    },
    nextButtonText() {
      let ret = "Next";
      // Check project vendor status
      switch (this.dataProjectDetail.vendorProjectStatus) {
        case "Open":
          // Check Bidding status
          switch (this.dataProjectDetail.biddingStatus) {
            case "Not Start":
              ret = this.stepIndex == 1 ? "Join Bidding" : "Next";
              break;
            case "Draft":
              ret = this.stepIndex == 1 ? "Edit Bidding" : "Next";
              break;
            case "Submitted":
              ret = this.stepIndex == 1 ? "View" : "Next";
              break;
            default:
              ret = this.stepIndex == 1 ? "Join Bidding" : "Next";
              break;
          }
          break;
        case "Re-Open":
          // Check Bidding status
          switch (this.dataProjectDetail.biddingStatus) {
            case "Not Start":
              ret = this.stepIndex == 1 ? "Re Submit" : "Next";
              break;
            case "Draft":
              ret = this.stepIndex == 1 ? "Edit Bidding" : "Next";
              break;
            case "Submitted":
              ret = this.stepIndex == 1 ? "View" : "Next";
              break;
            default:
              ret = this.stepIndex == 1 ? "Re Submit" : "Next";
              break;
          }
          break;
        case "On Process":
          // Check Bidding status
          switch (this.dataProjectDetail.biddingStatus) {
            case "Draft":
              ret = this.stepIndex == 1 ? "View" : "Next";
              break;
            case "Submitted":
              ret = this.stepIndex == 1 ? "View" : "Next";
              break;
            default:
              ret = this.stepIndex == 1 ? "View" : "Next";
              break;
          }
          break;
        case "Complete":
          // Check Bidding status
          switch (this.dataProjectDetail.biddingStatus) {
            case "Draft":
              ret = this.stepIndex == 1 ? "View" : "Next";
              break;
            case "Submitted":
              ret = this.stepIndex == 1 ? "View" : "Next";
              break;
            default:
              ret = this.stepIndex == 1 ? "View" : "Next";
              break;
          }
          break;
        case "Award":
          // Check Bidding status
          switch (this.dataProjectDetail.biddingStatus) {
            case "Not Start":
              ret = this.stepIndex == 1 ? "Next" : "Next";
              break;
            default:
              ret = this.stepIndex == 1 ? "View" : "Next";
              break;
          }
          break;
        default:
          ret = "Close";
          break;
      }
      return ret;
    },
    notjoinbidding() {
      if (
        this.dataProjectDetail.biddingStatus == "Not Start" &&
        this.dataProjectDetail.vendorProjectStatus == "Open"
      ) {
        return true;
      } else {
        return false;
      }
    },
    finishButton(/* prevIndex, nextIndex */) {
      return this.isEdit
        ? "Submit"
        : this.isAward
        ? this.dataProjectDetail.biddingStatus === "Not Start"
          ? "Close"
          : "Close"
        : "Close";
    },
  },
  methods: {
    async updatenotjoinbidding() {
      this.$loading(true);
      try {
        const result = await _projectservice.Notjoinbidding(
          parseInt(this.$route.params.projectId),
          this.$store.state.AppActiveUser.vendorID
        );

        if (!result || /^Error/.test(result)) {
          this.$notify({
            type: "error",
            title: "Not Join Bidding Failed",
            text: result || "Error",
          });
        } else if (result.message !== undefined) {
          this.$notify({
            type: "error",
            title: "Not Join Bidding Failed",
            text: result.message,
          });
        } else {
          this.$notify({
            type: "success",
            title: "Not Join Bidding Success",
            text: "Thank For Feedback",
          });
          this.$router.push("/").catch(() => {});
        }
      } catch (error) {
        this.$notify({
          type: "error",
          title: "Error",
          text: error.message,
        });
      } finally {
        this.$loading(false);
      }
    },
    async save() {
      // console.log("save");
      if (this.stepIndex === 2) await this.saveDraft();
      if (this.stepIndex === 3) this.isSaveDraft = true;
    },
    async onNextStep(step) {
      console.log("onNextStep", step);
      if (step === 1) {
        await this.validateVendorCriteria();
        if (await this.checkStep1()) {
          this.stepIndex = this.stepIndex + 1;
        }
      }
      if (step === 3) {
        this.isSaveDraft = false;
      }
      if (step === 4) {
        setTimeout(() => {
          if (this.isHavePOFile) {
            this.checkStep4backToListProject();
          }
          this.$loading(false);
        }, 2000);
      }
      this.checkStep = "";
      setTimeout(() => {
        this.checkStep = step;
      }, 100);
    },
    async DiagloBidding() {
      this.dialog.show = false;
      if (this.dialog.type === "success") {
        this.stepIndex = 2;
        this.isHaveFileTorProp = this.isHaveFileTor;
      } else {
        if (this.dialog.type === "confirmStep3") {
          const round = this.dataBiddingSubmitItem.biddingRound;
          this.dataBiddingSubmitItem.biddingStatus = "Submitted";
          this.$loading(true);
          if (round === 1) {
            await _projectservice.SubmitBiddingProject(
              this.dataBiddingSubmitItem
            );
          } else {
            await _projectservice.PostVendorReSubmitItemBiddingProject(
              this.dataBiddingSubmitItem
            );
          }

          this.$notify({
            type: "success",
            title: "Submit Bidding Success",
            text: "Please wait for procurement team for another process",
          });
          this.$loading(false);
          this.$router.push("/").catch(() => {});
        }

        if (this.dialog.type === "confirmStep4") {
          this.dataBiddingSubmitItem.biddingStatus = "Submitted";
          this.$loading(true);
          const result =
            await _projectservice.PostVendorReSubmitItemBiddingProject(
              this.dataBiddingSubmitItem
            );

          if (result.message !== undefined) {
            this.$loading(false);
            this.$notify({
              type: "success",
              title: "Submit PO File Failed.",
              text: result.message,
            });
          } else {
            this.$notify({
              type: "success",
              title: "Submit PO File Success",
              text: "Please wait for procurement team for another process",
            });
            this.$loading(false);
            this.$router.push("/").catch(() => {});
          }
        } else {
          this.$router.go(-1);
        }
      }
    },
    checkStep1() {
      // Check vendor pass criteria and status
      if (this.isVendorValid) {
        // Check vendor can bidding by project status and bidding status
        if (!this.isEdit) {
          return true;
        } else {
          this.dialog = {
            show: true,
            title: "Start Bid this Project.",
            text: "Your qualification is match with Project's vendor criteria.",
            type: "success",
          };
          return false;
        }
      } else {
        if (this.dataProjectDetail.projectStatus == "OpenBidding") {
          this.dialog = {
            show: true,
            title: "Cannot bid this project",
            text: "Your qualification is not match with this project's vendor criteria or document expire.",
            type: "error",
          };
          return false;
        }
        if (
          this.dataProjectDetail.projectStatus == "CloseBidding" &&
          this.dataProjectDetail.biddingStatus == "Not Start"
        ) {
          this.dialog = {
            show: true,
            title: "Cannot bid this project",
            text: "This project was closed already.",
            type: "error",
          };
          return false;
        }
        // Project status == Close Bidding
        else {
          this.isHaveFileTorProp = this.isHaveFileTor;
          return true;
        }
      }
    },
    checkStep3AttachmentAndSubmit() {
      if (this.isAward) {
        this.tabIndex = 3;
        this.stepIndex = this.stepIndex + 1;
        return true;
      } else {
        // Check if view mode don't do anything
        if (this.isEdit) {
          this.dialog = {
            show: true,
            title: "Confirm Submit Bidding",
            text: "Are you sure to submit your bidding? If you submit you can't chanage your information.",
            type: "confirmStep3",
          };
          return false;
        } else {
          this.$router.push("/").catch(() => {});
        }
      }
    },
    async checkStep4backToListProject() {
      // Check if view mode don't do anything
      if (
        this.dataProjectDetail.vendorProjectStatus === "Award" &&
        this.dataProjectDetail.biddingStatus === "Not Start"
      ) {
        this.dialog = {
          show: true,
          title: "Confirm Submit PO File",
          text: "Are you sure to submit your PO file? If you submit you can't chanage your information.",
          type: "confirmStep4",
        };
        return true;
      } else {
        this.$router.push("/").catch(() => {});
      }
    },
    callBackDataProjectDetail(dataProjectDetail) {
      this.dataProjectDetail = dataProjectDetail;
      this.isAward = dataProjectDetail.isProcurementSubmitPo ? true : false;
      const menuAward = {
        icon: "icon-book-open",
        name: "Award",
        component: "MainAward",
        step: 4,
      };
      if (this.isAward) this.steps.push(menuAward);
    },
    callBackIsHaveFileTor(isHaveFileTor) {
      this.isHaveFileTor = isHaveFileTor;
    },
    callBackBiddingSubmitItem(biddingSubmitItem) {
      this.dataBiddingSubmitItem = biddingSubmitItem;
    },
    async validateVendorCriteria() {
      this.$loading(true);
      const payload = {
        projectId: parseInt(this.$route.params.projectId),
        vendorId: this.$store.state.AppActiveUser.vendorID,
      };

      var result = await _projectservice.CheckVendorCriteria(payload);
      this.isVendorValid = result.data.data;
      console.log("isVendorValid", this.isVendorValid);
      this.$loading(false);
    },
    async callBackBiddingStep2Next() {
      // console.log("test 2");
      if (!this.isEdit) {
        this.stepIndex = this.stepIndex + 1;
      } else {
        // console.log("test 1");
        const isSaveDone = await this.saveDraft();
        if (isSaveDone) {
          this.isSaveDraftDone = true;
          this.stepIndex = this.stepIndex + 1;
          setTimeout(() => {
            this.isSaveDraftDone = false;
          }, 2000);
        }
      }
    },
    callBackAttachment(attachmentSubmit) {
      this.dataBiddingAttachment = attachmentSubmit;
    },
    callBackAttachmentAlreadyExist(attachment) {
      this.attachmentAlreadyExist = attachment;
    },
    async saveDraft() {
      if (!this.isAward) {
        this.$loading(true);
        this.dataBiddingSubmitItem.biddingStatus = "Draft";
        const round = this.dataBiddingSubmitItem.biddingRound;
        console.log("saveDraft", this.dataBiddingSubmitItem);

        const items = this.dataBiddingSubmitItem.item;
        for (const item of items) {
          const properties = [
            "offerUnitPrice",
            "offerUnitPriceRound2",
            "offerUnitPriceRound3",
            "offerUnitPriceRound4",
            "offerUnitPriceRound5",
            "offerUnitPriceRound6",
          ];
          if (round > 1) {
            const currentRoundPrice = item[`offerUnitPriceRound${round}`];
            const previousRoundPrice =
              round === 2
                ? item.offerUnitPrice
                : item[`offerUnitPriceRound${round - 1}`];

            if (currentRoundPrice > previousRoundPrice) {
              this.$notify({
                type: "error",
                title: "Validation Error",
                text: "New round price must be lower than previous round price",
              });
              this.isSaveDraft = false;
              this.$loading(false);
              return;
            }
          }
          for (const prop of properties) {
            if (item[prop] !== null) {
              if (item[prop] < 0) {
                this.$notify({
                  type: "error",
                  title: "Validation Error",
                  text: "Unit price cannot be negative",
                });
                this.isSaveDraft = false;
                this.$loading(false);
                return;
              }
              const decimalPlaces =
                item[prop].toString().split(".")[1]?.length || 0;
              if (decimalPlaces > 2) {
                this.$notify({
                  type: "error",
                  title: "Validation Error",
                  text: "Unit price cannot have more than 2 decimal places",
                });
                this.isSaveDraft = false;
                this.$loading(false);
                return;
              }
            }
          }
        }
        let result;
        if (round === 1) {
          result = await _projectservice.SubmitBiddingItemProject(
            this.dataBiddingSubmitItem
          );
        } else {
          result = await _projectservice.PostVendorReSubmitItemBiddingProject(
            this.dataBiddingSubmitItem
          );
        }
        // If submit without error
        this.$loading(false);
        if (result.message === undefined) {
          this.$notify({
            type: "success",
            title: "Save Bidding Items Success",
            text: "Goto next step to upload attachment",
          });
          this.isSaveDraft = false;
          return true;
        } else {
          this.$notify({
            type: "error",
            title: "Save Bidding Items Failed",
            text: `Cannot save ${result.message}`,
          });
          this.isSaveDraft = false;
          return false;
        }
      } else {
        this.isSaveDraft = false;
        return true;
      }
    },
    callBackBiddingStep3Next(value) {
      if (this.isSaveDraft === true) {
        this.saveDraft();
      } else {
        this.isHaveAttachFile = value;
      }
    },
    callBackBiddingStep4Next(/* value */) {
      // if (this.isAward) {
      //   this.isHavePOFile = value;

      this.$router.push("/").catch(() => {});
      // }
    },
    async callBackUpdateBiddingStatusAcknowledgePO() {
      this.dataBiddingSubmitItem.biddingStatus = "Submitted";
      this.$loading(true);
      const result = await _projectservice.PostVendorReSubmitItemBiddingProject(
        this.dataBiddingSubmitItem
      );

      if (result.message !== undefined) {
        this.$loading(false);
        this.$notify({
          type: "success",
          title: "Submit PO File Failed.",
          text: result.message,
        });
      } else {
        this.$notify({
          type: "success",
          title: "Submit PO File Success",
          text: "Please wait for procurement team for another process",
        });
        this.$loading(false);
        // this.$router.push("/").catch(() => {});
      }
    },
  },
  watch: {
    isHaveAttachFile(value) {
      if (value) {
        this.checkStep3AttachmentAndSubmit();
      }
    },
  },
};
</script>
